module.exports = __webpack_public_path__ + "img/mine30BoxBg.56302419.webp";